import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../../api';
import api from '../../../../api/endpoints';

const prepareDataTable = data => {
  const dataTable = [];

  data.forEach(item => {
    const el = {
      key: item.uuid,
      id: item.uuid,
      uuid: item.uuid,
      name: item.name,
      avatar_url: item.avatar_url,
      social_accounts: item.social_accounts,
      operations: item
    };
    dataTable.push(el);
  });

  return dataTable;
};

function* getGroupUsers({ payload: { signal, id, curr_page, page_size, onSuccess } }) {
  try {
    const { data } = yield call(fetch, {
      api: api.modifiers.regularusers.members.list,
      id,
      params: { page: curr_page, page_size },
      signal
    });

    const preparedData = {
      dataTable: prepareDataTable(data.results),
      message: data.message,
      count: data.count,
      next: data.next,
      previous: data.next
    };

    onSuccess && onSuccess(preparedData);
    yield put(actions.getGroupUsersDone(preparedData));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getGroupUsersFailed,
      endpoint: api.modifiers.regularusers.members.list.url
    });
  }
}

export const getGroupUsersSaga = takeEvery(types.GET_GROUP_USERS_REQUEST, getGroupUsers);